;(function ($) {
    // 智能推荐
    window.smartRec = {
        //详情页5秒钟弹关联窗口
        // relatedDialog:function(){
        //     var relateTimer = setTimeout(function () {
        //         showDialog();
        //     }, 5000);
        //
        //     function showDialog() {
        //         // 判断页面参数是否存在 判断gio用户分组是否为智能推荐分组
        //         if(pageConfig.jumpInfo.url && getUserInfo.getUserTeam() != 1){
        //             // 如果弹窗价格>产品价格，弹窗不出现
        //             var curPrice = $('.j-cur-price').text();
        //             var jumpPrice = parseInt(pageConfig.jumpInfo.price.slice(1));
        //             if (curPrice && curPrice != '咨询客服获取特惠价') {
        //                 curPrice = parseInt(curPrice.slice(1));
        //                 console.log(curPrice,jumpPrice);
        //                 if (curPrice < jumpPrice) {
        //                     return;
        //                 }
        //             }
        //             window.userRecordOption.triggerReason_var = '爆款';
        //             window.userRecordOption.closeType_var = getUserInfo.getUserTeam() == 4 || getUserInfo.getUserTeam() == 5 ? '自动' : '手动';
        //             gioTrackAction.popupDialog('爆款', pageConfig.jumpInfo.id).open();
        //             solution_msg.relatedDialog(pageConfig.jumpInfo.title, pageConfig.jumpInfo.highLight, pageConfig.jumpInfo.img,  pageConfig.jumpInfo.price, gotoLink, closeFunc)
        //         }
        //     }
        //
        //     function gotoLink() {
        //         // gioTrackAction.popupDialog('爆款',pageConfig.jumpInfo.id).click();
        //         window.open(pageConfig.jumpInfo.url)
        //     }
        //
        //     function closeFunc() {
        //         gioTrackAction.popupDialog('爆款',pageConfig.jumpInfo.id).close();
        //     }
        // },

        // 客服弹窗
        pvCustomerServicePopup:function(){
            // var pvNum = this.getPv();
            // if(pvNum > 2){
                this.showCustomerServicePopup('pv');
            // }

        },

        // 显示客服弹窗
        showCustomerServicePopup: function(type){
            if($('.customer-service-popup').length = 0 ){
                return;
            }

            function open() {
                if(!type){
                    type = '';
                    $('.customer-service-popup').removeClass('customer-service-popup-hide');
                    loadQiDianSdk()
                }else{
                    if(common.getCookie('isShowCustomerServicePopup')){
                        return;
                    }

                    $('.customer-service-popup').removeClass('customer-service-popup-hide');
                    loadQiDianSdk()
                }
                window.userRecordOption ? (window.userRecordOption.triggerReason_var = type == 'BrowseSpe' ? '浏览参数' : '3PV') : '';
                gioTrackAction.popupDialog('在线客服').open();
            }

            //加载dom js
            function loadQiDianSdk() {
                if(window.__qd_wpas){
                    $('.customer-service-popup').removeClass('customer-service-popup-hide');
                    return;
                }
                var qdNode = document.createElement("script");
                qdNode.id = 'qd28857367169ac2b0a177f5cd3c7e62c6afab76040a';
                qdNode.src = "https://wp.qiye.qq.com/qidian/2885736716/9ac2b0a177f5cd3c7e62c6afab76040a";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(qdNode, s);
                qdNode.onload = function () {
                    $('.customer-service-popup').removeClass('customer-service-popup-hide');
                    console.log('企点客服sdk 加载完毕')
                };
            }
            open();
        },

        // 点击客服
        clickCustomerServicePopup:function(){
            gioTrackAction.popupDialog('在线客服').click();
        },

        // 显示客服弹窗
        closeCustomerServicePopup: function(){
            $('.customer-service-popup').addClass('customer-service-popup-hide');
            common.setCookie('isShowCustomerServicePopup',1,1);
            gioTrackAction.popupDialog('在线客服').close();
        },

        //设置pv
        setPv:function(){
            var pvNum = common.getCookie('pagePv');
            if(!pvNum){
                common.setCookie('pagePv',1);
            }else{
                pvNum = parseInt(pvNum) + 1;
                common.setCookie('pagePv',pvNum);
            }
        },

        //获取pv
        getPv:function(){
            return parseInt(common.getCookie('pagePv') || 0);
        },

        // 推荐位曝光 + 点击
        getRecommendImp: function (){

            // 获取所有推荐位的dom
            if(!document.querySelector('.gio-recommendation-box')){
                return;
            }

            var recommendDomArray = [];
            var recoBoxArr = [];
            getRecommendDomArray();
            function getRecommendDomArray() {
                recommendDomArray = [];
                recoBoxArr = document.querySelectorAll('.gio-recommendation-box');
                for(var i = 0;i<recoBoxArr.length;i++){
                    var subBox = recoBoxArr[i].querySelectorAll('.gio-recommendation');
                    for(var j = 0;j<subBox.length;j++){
                        recommendDomArray.push(subBox[j])
                    }
                }
            }

            if(recommendDomArray.length === 0 ){
                return;
            }

            // 窗口高度
            var windowH = 0;
            var windowW = 0;
            getwindowSize();

            //推荐位id数组，其中的数据为曝光过的，不进行再次曝光
            var exposureIdArr = [];

            intoVisibleRange();
            // 判断推荐位是否进入到窗口中
            window.addEventListener('scroll', function () {
                    intoVisibleRange();
                }
            );
            //添加touch的监听针对wap端左右滑动的swiper
            for(var i = 0;i<recoBoxArr.length;i++){
                recoBoxArr[i].addEventListener('touchend',function () {
                    // console.log('触发滑动');
                    intoVisibleRange();
                })
            }

            //触发遍历推荐位是否进入可视范围
            function intoVisibleRange() {
                for(var i = 0;i<recommendDomArray.length;i++){
                    var recoToTopH = recommendDomArray[i].getBoundingClientRect().bottom;
                    var recoToTopW = recommendDomArray[i].getBoundingClientRect().right;
                    if((recoToTopH > 0 && recoToTopH < windowH) && (recoToTopW > 0 && recoToTopW < windowW)){ //纵向和横向判断推荐位内容进入可视范围
                        var recoId = recommendDomArray[i].getAttribute('data-recommendation-id');
                        var recoName = recommendDomArray[i].getAttribute('data-recommendation-name');
                        var recoTitle = recommendDomArray[i].getAttribute('data-recommendation-title');
                        var recoContentID = recommendDomArray[i].getAttribute('data-recommendation-content-id');
                        if(exposureIdArr.indexOf(recoId) === -1){
                            exposureIdArr.push(recoId);
                            // console.log('推荐位曝光',recoName, recoId);
                            gioTrackAction.recommendImp(recoName, recoId, recoTitle, recoContentID);
                        }
                    }
                }
            }

            // 点击监听推荐位点击事件
            function clickEvent() {
                for(var i = 0;i<recommendDomArray.length;i++){
                    var recoId = recommendDomArray[i].getAttribute('data-recommendation-id');
                    var recoName = recommendDomArray[i].getAttribute('data-recommendation-name');
                    var recoTitle = recommendDomArray[i].getAttribute('data-recommendation-title');
                    var recoContentID = recommendDomArray[i].getAttribute('data-recommendation-content-id') || '';
                    recommendDomArray[i].addEventListener('click', function () {
                        gioTrackAction.recommendContentClick(recoName, recoId, recoTitle, recoContentID);
                    })
                }
            }
            clickEvent();

            // 获取窗口尺寸
            function getwindowSize(){
                windowH = window.innerHeight || document.documentElement.clientHeight;
                windowW = window.innerWidth || document.documentElement.clientWidth;
            }
            // 在调整窗口大小后重新设置窗口尺寸
            window.addEventListener("resize", function () {
                getwindowSize();
            }, false);



            listenerPageHeight();
            // 监听页面的高度变化，用于监听wap底部滚动加载的推荐位
            function listenerPageHeight() {
                setTimeout(function () {
                    var bodyH = 0;//页面的高度

                    bodyH = document.body.scrollHeight;
                    setInterval(function () {
                        if(document.body.scrollHeight !== bodyH){
                            // console.log('页面高度变化', document.body.scrollHeight,bodyH)
                            bodyH = document.body.scrollHeight;
                            getRecommendDomArray();
                        }
                    },500)
                },3000)
            }

            return {
                intoVisibleRange:intoVisibleRange()
            }


        },

        // 跳转url 并记录
        goto: function (url, fromPosition, id, title) {
            if(!url){
                return;
            }

            var idPos = '';
            if(document.querySelector('#gioRecommendPosition')){
                idPos = document.querySelector('#gioRecommendPosition').value;
            }

            //获取推荐位
            var fromPosition = fromPosition || idPos || '';
            if (fromPosition) {
                var newUrl = url;
                if (url.split('?').length > 1) {
                    newUrl = newUrl + "&recommendPosition=" + fromPosition;
                } else {
                    newUrl = newUrl + "?recommendPosition=" + fromPosition;
                }
                gioTrackAction.recommendContentClick(fromPosition, id, title);
                go(newUrl)
            } else {
                go(url)
            }

            function go(url) {
                if(cateData.device === 'wap'){
                    window.location.href = url;
                }else{
                    window.open(url);
                }
            }
        },

        // 设置订阅计划弹层
        isSubscribeDialog: function () {
            // 判断链接参数 utm_campaign=member__fy24q4-1226
            if (common.getUrlPara('utm_campaign') && common.getUrlPara('utm_campaign') === 'member__fy24q4-1226') {
                window.solution_msg.subscribeDialog();
            }
        },

        // 设置推荐弹层
        isRecommendDialog: function () {
            // 指定路由
            var pathArr = ['/campaign', '/account', '/user', '/auth/', '/meeting/', '/miaosha', '/dtfbooth'],
                index = 0;
            // 判断cookie 弹出订阅计划弹层 指定路由范围不弹出
            pathArr.forEach(function (item) {
                if (window.location.pathname.indexOf(item) > -1) {
                    index++;
                }
            });
            // 判断是否已经弹出过
            if (!common.getCookie('subscribePlanClick_2025701') && index === 0) {
                var arr = common.isM ? ['C'] : ['A'];
                var arr_index = Math.floor((Math.random()*arr.length));
                common.isM ? window.solution_wap_msg.subscribePlanDialog(arr[arr_index]) : window.solution_msg.subscribePlanDialog(arr[arr_index]);
                gioTrackAction.gio_base('PopUp_HuiyuanLiyu', {
                    "in_app_message_name": "会员礼遇" + arr[arr_index] + "类弹窗",
                });
            }
        },

        // 企点云MA推送弹窗
        maPushDialog: function () {
            return;
            // 判断是否已经弹出过
            if(common.getCookie('maPushDialogCookie')){
                return;
            }

            // 获取企点云推送弹窗数据
            var info = {
                userId: '',
                cookieId: common.getGlobalUserId()
            }

            if(common.isLogin()){
                info.userId = common.isLogin().memberId;
            }

            common.getJson(solution_host + '/api/qi_cloud/get', info, function (res) {
                // console.log(res)
                if(res.errCode === 0) {

                    // 判断单前页面的url是否包含 res.data.path
                    if(window.location.href.indexOf(res.data.path) === -1){
                        return;
                    }

                    var img = common.isM?res.data.image_wap:res.data.image_pc;
                    var url = res.data.url;
                    var id = res.data.id;
                    var delaytime = Number(res.data.delaytime || 0) * 1000;

                    setTimeout(function () {
                        // 预加载img
                        var imgObj = new Image();
                        imgObj.src = img;
                        imgObj.onload = function () {
                            if (!window.isFocusInput) {
                                solution_msg.maPushDialog(img, url, id);
                            }
                        }
                    }, delaytime);
                }
            })

        },

        // 百度推广记录token
        adTokenBd: function () {

            // 判断当前页面带有参数 bd_vid 且值不为空，调用接口，不重复调用
            if (!common.getUrlPara('bd_vid') || common.getCookie('adTokenBd')) return;

            var info = {
                url: location.href,
                globalUserId: common.getGlobalUserId()
            }

            if(common.isLogin()){
                info.session = common.isLogin().session;
                info.OCSESSID = common.isLogin().OCSESSID;
            }

            common.postJson(solution_host + '/api/account/adtoken/bd', info, function (res) {
                if(res.errCode === 0) {
                    common.setCookie('adTokenBd', 1);
                }
            })
        },

        // 绑定微信扫码登录
        isBindDialog: function () {
            // 指定路由
            var pathArr = ['/login'],
                index = 0;
            // 判断cookie 弹出订阅计划弹层 指定路由范围不弹出
            pathArr.forEach(function (item) {
                if (window.location.pathname.indexOf(item) > -1) {
                    index++;
                }
            });
            if (!common.isLogin() && index === 0 && localStorage.getItem('unikey') && (common.isWx || !common.isM)) {
                common.postJson('/api/account/wxlogin/st', {
                    unikey: localStorage.getItem('unikey'),
                }, function (res) {
                    console.log('是否绑定账号', res);
                    if (res.data.status === 0) {
                        msg.bindMobileDialog();
                    }
                })
            }
        },

        // 登录后进leaders系统
        addcustomer: function () {
            // 判断是否24小时内，是否调用过
            if(common.getCookie('addcustomer') || !common.isLogin()) return false;
            var utmObj = {};
            if (common.getCookie('utmObj')) {
                utmObj = JSON.parse(common.getCookie('utmObj'));
            }
            getUserInfoDef.then(function () {
                $.ajax({
                    url: window.solution_host + "/api/campaign/addcustomer",
                    method: 'POST',
                    data: {
                        "userId": getUserInfo.options.userId,
                        "name": getUserInfo.options.name,
                        "mobile": getUserInfo.options.mobile,
                        "email": getUserInfo.options.email,
                        "company": getUserInfo.options.enterpriseName,
                        "utmSource": utmObj.utm_source,
                        "utmMedium": utmObj.utm_medium,
                        "utmCampaign": utmObj.utm_campaign,
                        "utmContent": utmObj.utm_content,
                        "utmTerm": utmObj.utm_term,
                        "utmModule": '网站登录',
                        "formTitle": '网站登录',
                        "from": '网站登录',
                    },
                    success: function (res) {
                        common.setCookie('addcustomer', 1, 1);
                    },
                    error: function (error) {
                    }
                });
            });
        },

        init:function () {
            this.setPv();

            var _this = this;
            setTimeout(function () {
                _this.pvCustomerServicePopup();
                _this.getRecommendImp();
                _this.isRecommendDialog();
                _this.addcustomer();
                _this.adTokenBd();
                _this.isSubscribeDialog();
            }, 2000);

            $(document).ready(function() {
                // 为所有输入框添加焦点事件监听器
                $('input').on('focus', function() {
                    window.isFocusInput = true;
                });
                common.setupScrollBehavior(".solution-footer .top-box");
            });

            this.maPushDialog();

        }
    };

    smartRec.init();
})(jQuery);


